export default "dist/images/block-button-grouped-2.ce6e2bb.png";